import ReactDOM from 'react-dom/client'

import { LangProvider } from './context/LangContext';

import { Provider } from 'react-redux'
import { store } from "./redux";

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
    <Provider store={store}>
        <LangProvider>
            <App />
        </LangProvider>
    </Provider>
)